"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isNil_1 = __importDefault(require("lodash/isNil"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const reselect_1 = require("reselect");
const DDPProvider_1 = require("./DDPProvider");
const useDebounce_1 = __importDefault(require("./useDebounce"));
const createResourcesSelectorFactory_1 = __importDefault(require("./selectors/createResourcesSelectorFactory"));
const createQueriesSelector = (0, createResourcesSelectorFactory_1.default)('queries');
const constant = (x) => () => x;
const createQuerySelector = (request) => (0, reselect_1.createSelector)(createQueriesSelector(constant([request]), (state, id) => (Object.assign({ id }, state))), (queries) => queries[0]);
const noop = () => { };
const useDDPQuery = (request, options = {}) => {
    const { onReady, onError, debounceMs } = options;
    const ddpConnector = (0, react_1.useContext)(DDPProvider_1.DDPContext);
    const [currentRequest, nextRequest] = (0, useDebounce_1.default)(request, debounceMs);
    const selectQuery = (0, react_1.useMemo)(() => createQuerySelector(nextRequest), [nextRequest]);
    (0, react_1.useEffect)(() => {
        if ((0, isNil_1.default)(currentRequest)) {
            return noop;
        }
        if (!(0, isPlainObject_1.default)(currentRequest)) {
            throw new Error('Query request must be a plain object');
        }
        const { resource } = ddpConnector.queryManager.getOrCreateResource(currentRequest);
        let handle = resource.require();
        if (onReady || onError) {
            handle.promise.then(onReady, onError);
        }
        return () => {
            if (handle) {
                handle.release();
                handle = null;
            }
        };
    }, [onReady, onError, ddpConnector.queryManager, currentRequest]);
    return (0, react_redux_1.useSelector)(selectQuery);
};
exports.default = useDDPQuery;
//# sourceMappingURL=useDDPQuery.js.map